module.exports = __webpack_public_path__ + "img/transaction.8c3a0361.svg";